// extracted by mini-css-extract-plugin
module.exports = {"team":"styles_team__2BDi3","head":"styles_head__2_Rc4","text":"styles_text__3gPaY","members":"styles_members__1vQtL"};